import { PayloadAction } from "@reduxjs/toolkit";
import { AlertHelper } from "helpers";
import { EAlertType } from "helpers/alertHelper";
import {
  IApiResponse,
  IErrorResponse,
  IGetPrepareDetailRequest,
  IPaginateApiResponse,
  IPaginationRequest,
  IPrepare,
  IPrepareDetail,
  IUpdatePrepareDocumentRequest,
} from "model";
import { put, takeEvery, call } from "redux-saga/effects";
import { PrepareActions } from "redux/actions";
import PrepareApiService from "services/PrepareApiService";

function* getAllPrepareDocuments(action: PayloadAction<IPaginationRequest>) {
  try {
    const result: IPaginateApiResponse<IPrepare[]> = yield call(
      PrepareApiService.getAllPrepareDocuments,
      action.payload
    );
    if (result.succeeded) {
      yield put(PrepareActions.getAllPrepareDocuments.success(result));
    } else {
      const error = result as IErrorResponse;
      yield put(PrepareActions.getAllPrepareDocuments.failed(error));
    }
  } catch (error) {
    yield put(PrepareActions.getAllPrepareDocuments.failed(error));
  }
}

function* getPrepareDocumentDetail(
  action: PayloadAction<IGetPrepareDetailRequest>
) {
  try {
    const result: IPaginateApiResponse<IPrepareDetail[]> = yield call(
      PrepareApiService.getPrepareDocumentDetail,
      action.payload
    );
    if (result.succeeded) {
      yield put(PrepareActions.getPrepareDocumentDetail.success(result));
    } else {
      const error = result as IErrorResponse;
      yield put(PrepareActions.getPrepareDocumentDetail.failed(error));
    }
  } catch (error) {
    yield put(PrepareActions.getPrepareDocumentDetail.failed(error));
  }
}

function* updatePrepareDocument(
  action: PayloadAction<IUpdatePrepareDocumentRequest>
) {
  try {
    const result: IApiResponse<IPrepare> = yield call(
      PrepareApiService.updatePrepareDocument,
      action.payload
    );
    if (result.succeeded) {
      yield put(PrepareActions.updatePrepareDocument.success(result.data!));
      AlertHelper.showAlert("Update Document Successfully", EAlertType.SUCCESS);
    } else {
      const error = result as IErrorResponse;
      yield put(PrepareActions.updatePrepareDocument.failed(error));
    }
  } catch (error) {
    yield put(PrepareActions.updatePrepareDocument.failed(error));
  }
}

export function* Watcher() {
  yield takeEvery(
    PrepareActions.getAllPrepareDocuments.request,
    getAllPrepareDocuments
  );
  yield takeEvery(
    PrepareActions.getPrepareDocumentDetail.request,
    getPrepareDocumentDetail
  );
  yield takeEvery(
    PrepareActions.updatePrepareDocument.request,
    updatePrepareDocument
  );
}
